import { Injectable } from '@angular/core';
import { StorageProvider } from './storage.provider';
import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';

export enum HapticType {
    Click,
    Success,
    Error,
    Back,
}

@Injectable({ providedIn: 'root' })
export class HapticsProvider {
    constructor(private storageProvider: StorageProvider) { }

    async vibrate(type: HapticType) {
        if (this.storageProvider.isDesktopPlatform) return;

        if (this.storageProvider.isAndroid) {
            switch (type) {
                case HapticType.Click:
                    await Haptics.vibrate({ duration: 1 });
                    break;
                case HapticType.Success:
                    await Haptics.notification({ type: NotificationType.Success });
                    break;
                case HapticType.Error:
                    await Haptics.notification({ type: NotificationType.Error });
                    break;
                case HapticType.Back:
                    await Haptics.vibrate({ duration: 1 });
                    break;
            }
        }
        else if (this.storageProvider.isIos) {
            switch (type) {
                case HapticType.Click:
                    await Haptics.impact({ style: ImpactStyle.Medium });
                    break;
                case HapticType.Success:
                    await Haptics.notification({ type: NotificationType.Success });
                    break;
                case HapticType.Error:
                    await Haptics.notification({ type: NotificationType.Error });
                    break;
                case HapticType.Back:
                    await Haptics.impact({ style: ImpactStyle.Medium });
                    break;
            }
        }
    }
}